(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-kns-product]').forEach((root) => {
      if (root.dataset.knsInitialized) return;
      root.dataset.knsInitialized = 'true';
      const own = (selector) => Array.from(root.querySelectorAll(selector)).filter(el => el.closest('[data-kns-product]') === root);
      const source = own('[data-kns-json]')[0];
      if (!source) return;
      let data;
      try { data = JSON.parse(source.textContent); } catch (_) { return; }
      const variants = data.variants || [];
      const format = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:root.dataset.currency || 'USD'}).format(value / 100);
      const update = (id) => {
        const variant = variants.find(v => String(v.id) === String(id));
        if (!variant) return;
        own('input[name="id"]').forEach(input => { input.value = variant.id; });
        own('[data-kns-price]').forEach(el => { el.textContent = format(variant.price); });
        own('[data-kns-compare]').forEach(el => { el.textContent = variant.compare_at_price > variant.price ? format(variant.compare_at_price) : ''; });
        own('[data-kns-add]').forEach(button => {
          button.disabled = !variant.available;
          button.textContent = variant.available ? button.dataset.availableLabel : button.dataset.soldLabel;
        });
        if (variant.featured_image && variant.featured_image.src) own('[data-kns-main-image]').forEach(img => { img.src = variant.featured_image.src; img.removeAttribute('srcset'); });
      };
      own('[data-kns-variant]').forEach(select => select.addEventListener('change', () => update(select.value)));
      own('[data-kns-image]').forEach(button => button.addEventListener('click', () => {
        own('[data-kns-main-image]').forEach(img => { img.src = button.dataset.knsImage; img.removeAttribute('srcset'); });
        own('[data-kns-image]').forEach(el => el.setAttribute('aria-pressed', el === button ? 'true' : 'false'));
      }));
      const initial = own('[data-kns-variant]')[0] || own('input[name="id"]')[0];
      if (initial) update(initial.value);
    });
    scope.querySelectorAll('[data-kns-slider]').forEach(root => {
      if (root.dataset.knsInitialized) return;
      root.dataset.knsInitialized='true';
      const slides = Array.from(root.querySelectorAll('.kns-sld-item'));
      if (!slides.length) return;
      let index=0;
      const change = step => {
        index=(index+step+slides.length)%slides.length;
        slides.forEach((slide,i) => {slide.classList.toggle('kns-sld-active',i===index);slide.setAttribute('aria-hidden',i===index?'false':'true');});
      };
      root.querySelectorAll('.kns-sld-left,.kns-sld-right').forEach(control => {
        control.setAttribute('role','button');control.setAttribute('tabindex','0');
        const step=control.classList.contains('kns-sld-left')?-1:1;
        control.setAttribute('aria-label',step<0?'Previous slide':'Next slide');
        control.addEventListener('click',()=>change(step));
        control.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();change(step);}});
      });
      change(0);
    });
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
